import styled from 'styled-components';

import { sizeUp } from '~/theme';

export const Container = styled.section({});

export const CardsList = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: sizeUp('20rem', ['xl', '43rem']),

  marginBlockStart: '18rem',

  [theme.breakpoint.media.min.lg]: {
    flexDirection: 'row',
  },
}));
